import Dialog from '../../../../../../BaseComponents/Dialog/EDDialog';
import React, { useState, useCallback } from 'react';
import EDIconButton from '../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import { AttestMeddelandeView } from './AttestMeddelande/AttestMeddelande';
import { FakturaDelType__Associations_Faktura__Associations_Attestmeddelande_All } from '../../FakturaDel/Queries/_QueryTypes/FakturaDelType';
import mergeSort from '../../../../../../Utils/mergeSort';
import { BokforderMessagesView } from '../../../../Ekonomi/ObjektVyer/Bokforder/Components/BokforderMessages/BokforderMessages';
import { BokforderType__Associations_Meddelande_All } from '../../../../Ekonomi/ObjektVyer/Bokforder/Queries/_QueryTypes/BokforderType';

export enum RutinEnum {
  FAKTURAATTEST = 'FAKTURAATTEST',
  BOKFORDER = 'BOKFORDER',
}

interface IProps {
  id: string;
  disabled?: boolean;
  hidden?: boolean;
  messages: any;
  rutin: RutinEnum;
}

const MessageListIkon: React.FC<React.PropsWithChildren<IProps>> = props => {
  const [open, setOpen] = useState(false);

  const onClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      setOpen(!open);
    },
    [open]
  );

  const compareMessages = (a: any, b: any) => {
    const aDate = new Date(a.DATUM + ' ' + a.TID);
    const bDate = new Date(b.DATUM + ' ' + b.TID);

    if (aDate.getTime() > bDate.getTime()) {
      return -1;
    }

    if (bDate.getTime() > aDate.getTime()) {
      return 1;
    }

    return 0;
  };

  return !props.hidden ? (
    <>
      <EDIconButton
        onClick={onClick}
        icon="email"
        tooltip="Visa meddelande"
        margin="dense"
        padding="dense"
        disabled={props.disabled}
      />
      <Dialog
        title="Meddelande"
        open={open}
        onClose={() => setOpen(false)}
        footerActions={[{ label: 'Stäng', onClick: () => setOpen(false) }]}
      >
        {props.rutin === RutinEnum.FAKTURAATTEST && (
          <AttestMeddelandeView
            messages={mergeSort(
              (props.messages as FakturaDelType__Associations_Faktura__Associations_Attestmeddelande_All[]) ??
                [],
              compareMessages
            )}
            id={props.id ?? null}
          />
        )}
        {props.rutin === RutinEnum.BOKFORDER && (
          <BokforderMessagesView
            messages={mergeSort(
              (props.messages as BokforderType__Associations_Meddelande_All[]) ??
                [],
              compareMessages
            )}
            id={props.id ?? null}
          />
        )}
      </Dialog>
    </>
  ) : (
    <></>
  );
};

export default MessageListIkon;
